import { useEffect, useState } from "react";
import { faqs } from "../../../mocks/chiagua";

export default function Faq() {
  const [openId, setOpenId] = useState<number | null>(1);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <span className="text-primary-600 text-sm font-semibold tracking-widest">FAQ</span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-2">吃瓜频道常见问题</h2>
          <p className="text-foreground-600 text-sm md:text-base mt-3">
            关于弹幕、连麦、可信度与社区规范，你想知道的都在这里。
          </p>
        </div>

        <div className="mt-8 md:mt-10 flex flex-col gap-3">
          {faqs.map((f) => {
            const isOpen = openId === f.id;
            return (
              <div
                key={f.id}
                className={`bg-background-100/70 border rounded-2xl overflow-hidden transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200/70"
                }`}
              >
                <button
                  onClick={() => setOpenId(isOpen ? null : f.id)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="text-foreground-900 font-medium text-sm md:text-base">{f.q}</span>
                  <span
                    className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-600"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-foreground-600 text-sm leading-relaxed">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}